import React, { useState, useEffect, Fragment } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import {
  Checkbox,
  Column,
  FormGroup,
  Input,
  OverlayTrigger,
  PopOver,
  Table,
  Loading,
} from '@tencent/spaui';
import _ from 'lodash';
import classNames from 'classnames';
import get from 'lodash/get';
import jrQrcode from 'jr-qrcode';
import { useSelector } from 'react-redux';
import { actionSubTypeRender } from './common/actionSubTypeRender';
import { Tags } from '../../../consts/Tags';
import { leadsTypeTreeForTableFilter } from '../../../consts/leadsTypeTree';
import { RPCFactory } from '../../../utils/RequestUtil';
import { callResultTips, leadsTagTips, leadsCallCleaningTagTips } from '../../../consts/Tips';
import { LeadsDataFilterShortcut as dateShortcuts } from '../../../consts/Common';
import { LeadsTagSelector } from './LeadsTagSelector';
import { store } from '../../../store/Store';
import { isXunda, judgeIsFromTMC } from '../../../utils';
import { isSubAccount } from '../../../consts/multiAccountConfig';

const getXundaPoolKeyName = () => {
  if (isXunda('车')) return '商家';
  return '楼盘';
};

export const QrcodeOverlay = ({ _data }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const size = 128;
  const styleContainer = {
    width: size,
    height: size,
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
    boxShadow: 'rgb(0 0 0 / 5%) 0px 6px 24px 0px, rgb(0 0 0 / 8%) 0px 0px 0px 1px',
  };
  const styleCanvas = {
    width: '100%',
    height: '100%',
  };
  const styleTitle = {
    textAlign: 'center',
    paddingBottom: 8,
  };
  useEffect(() => {
    const opt = { padding: 0 };
    RPCFactory.leadsManage
      .getPreviewUrl(_data.leadsId, _data.pageId)
      .done((data) => {
        setLoading(false);
        const url = _.get(data, 'preview_url', '');
        if (!data) {
          setErr('系统繁忙，请稍后再试');
          return;
        }
        if (data && data.preview_url === '') {
          setErr('功能正在升级中，尽请期待');
          return;
        }
        const codeSource = jrQrcode.getQrBase64(url, opt);
        setContent(codeSource);
      })
      .fail(() => {
        setLoading(false);
        setErr('系统繁忙，请稍后再试');
      });
  }, [_data]);

  let code = null;
  if (loading) {
    code = <Loading />;
  } else if (content) {
    code = <img src={content} style={styleCanvas} />;
  } else if (err) {
    code = <div style={{ width: '6em', display: 'inline-block' }}>{err}</div>;
  }

  return (
    <div>
      <p style={styleTitle}>微信扫码预览落地页</p>
      <div className="overlay-qrcode__code" style={styleContainer}>
        {code}
      </div>
    </div>
  );
};

const StatePoper = () => {
  const state = useSelector(s => s.global);

  return (
    <div className="poptable" style={{ maxHeight: 400, overflow: 'auto' }}>
      {/* {
        _.get(state, 'stateTips', []).map((item) => (
          <Fragment key={item.title}>
            <span>{item.title}</span>
          </Fragment>
        ))
      } */}
      <Table hideThead={true} data={state.stateTips || []}>
        <Column name="enumValue" minWidth={80}>
          线索状态
        </Column>
        <Column name="enumDetail">定义</Column>
      </Table>
    </div>
  );
};

const renderSex = (type, name, value, data) => {
  if (type != 'head') {
    const Sex = { 2: '男', 1: '女' };
    return Sex[value] ? Sex[value] : '--';
  }
  return value;
};
// 互动内容  add by fightingliu
const renderCustomQa = (type, name, value) => {
  if (type !== 'head') {
    try {
      let text = '';
      const valueObject = JSON.parse(value);
      Object.keys(valueObject).forEach((key) => {
        text = `${text + key}:${valueObject[key]}/`;
      });
      if (text.length < 15) {
        return text || '-';
      }
      const popover = (
        <PopOver style={{ maxWidth: 550 }}>
          {text}
        </PopOver>
      );
      return (
        <div>
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <span>{text.slice(0, 14)}...</span>
          </OverlayTrigger>
        </div>
      );
    } catch (e) {
      return value;
    }
  } else {
    return value;
  }
};
const getLength = (str, charLen) => {
  const l = str.length; 
  let len = charLen; 
  for(i=0; i<l; i++) { 
    if ((str.charCodeAt(i) & 0xff00) != 0) { 
      len --; 
    } 
  }
  return len;
};
const renderBundle = (type, name, value, data) => {
  if (type != 'head') {
    try {
      let text = '';
      const valueObject = JSON.parse(value);
      Object.keys(valueObject).forEach((key) => {
        text = `${text + key}:${valueObject[key]}/`;
      });

      let showText = '';
      const len = getLength(text, 30);
      if (text && text.length >= len) {
        showText = `${text.slice(0, len)}...`; // `${text.substr(0, 6)}...`;
      } else {
        showText = text;
      }
      return <div title={text}>{showText}</div>;
    } catch (e) {
      return value;
    }
  } else {
    return value;
  }
};

const renderFollowRecord = (type, name, value, data) => {
  if (type != 'head') {
    // let showText = '';

    // if (value && value.length >= 6) {
    //   showText = `${value}...`; // `${value.substr(0, 6)}...`;
    // } else {
    //   showText = value;
    // }
    return <div title={value}>{value}</div>;
  }
  return value;
};

const renderFollowTagName = (type, name, value, data) => {
  const popoverStyle = {
    maxWidth: '550px',
  };
  const tips = [
    { enumValue: '未分配', enumDetail: '市场推广获取线索后，线索初始状态' },
    { enumValue: '已分配待跟进', enumDetail: '线索被分配给某位员工后，线索初始状态' },
    { enumValue: '跟进中', enumDetail: '未接通或确认初步意向，需要继续跟进' },
    { enumValue: '已转换-潜在客户', enumDetail: '确认有兴趣，但是需要进一步了解产品情况，线索被转换为潜在客户' },
    { enumValue: '已转换-高意向客户', enumDetail: '确认很感兴趣，产品符合需求，考虑中，线索被转换为高意向客户' },
    { enumValue: '已转换-已成单', enumDetail: '表示已经成交' },
    { enumValue: '无效-重复', enumDetail: '重复线索，已有人在跟进' },
    { enumValue: '无效-非本人', enumDetail: '线索信息非用户本人信息，确认无效' },
    { enumValue: '无效-未接通', enumDetail: '电话空号、停机、一直未接通' },
    { enumValue: '无效-无意向', enumDetail: '线索信息为用户本人信息，沟通确认无意向' },
    { enumValue: '无效-定向外', enumDetail: '用户不在定向范围内' },
    { enumValue: '无效-其他', enumDetail: '' },
  ];

  const popover = (
    <PopOver style={popoverStyle}>
      <StatePoper />
      {/* <div className="poptable">
        <Table hideThead={true} data={tips}>
          <Column name="enumValue" minWidth={80}>
            线索状态
          </Column>
          <Column name="enumDetail">定义</Column>
        </Table>
      </div> */}
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value}</span>;
};
const renderWxNickname = (type, name, value, data) => {
  const tips = '受个保法影响，当且仅当线索来源=微信原生落地页且该用户同时添加了广告主客服企业微信好友后，线索通才可披露该用户微信昵称，其他均显示空。若用户分享落地页至他人填写留资并添加企微好友时可能会导致微信昵称信息匹配有误差。';

  const popover = <PopOver style={{ width: 550 }}>{tips}</PopOver>;
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value || '-'}</span>;
};
const renderLgMethod = (type, name, value, data) => {
  if (type !== 'head') {
    return <div>{value ? Tags.lgMethodTags[value] : ''}</div>;
  }
  return <div>{'LG处理方式'}</div>;
};
const renderRelatedLeadsIds = (type, name, value, data) => {
  const popoverStyle = {
    maxWidth: '550px',
  };
  const tips = '同一用户历史提交的其他线索';

  const popover = <PopOver style={popoverStyle}>{tips}</PopOver>;
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value}</span>;
};

const renderAccountId = (type, name, value, data) => {
  if (type == 'head') {
    const popover = (
      <PopOver
        style={{
          maxWidth: '550px',
        }}
      >
        表示线索的上报方账号，不等同于产生线索的推广账号advertise_id
      </PopOver>
    );
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value}</span>;
};

const renderCallTimes = (type, name, value, data) => {
  if (type != 'head') {
    const popover = (
      <PopOver
        style={{
          maxWidth: '550px',
        }}
      >
        {`${data.callTouchedTimes || 0}次接通, ${data.callNotTouchedTimes || 0}次未接通`}
      </PopOver>
    );
    return (
      <div>
        {value || 0}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value}</span>;
};

const renderBroadCast = (type, name, value, data) => {
  if (type === 'head') return <span>{value}</span>;
  return <span>{data.isBroadCastLeads === 1 ? '是' : '否'}</span>;
};

const renderFxdPool = (type, name, value, data) => {
  if (type === 'head') return value;
  const poolId = data.leadsPoolId;
  if (!poolId) return '-';
  const xundaStore = get(store.getState(), 'xunda', {});
  const pools = xundaStore.pools || [];
  for (const item of pools) {
    if (item && item.leads_pool_id === data.leadsPoolId) {
      return item.name;
    }
  }
  return '-';
};

const renderTouchTagName = (type, name, value, data) => {
  const popoverStyle = {
    maxWidth: '550px',
  };

  const popover = (
    <PopOver style={popoverStyle}>
      <div className="poptable">
        <Table hideThead={true} data={callResultTips}>
          <Column name="enumValue" minWidth={80}>
            枚举值
          </Column>
          <Column name="enumDetail">说明</Column>
        </Table>
      </div>
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return value;
};

function renderLeadsTags(type, name, value, data) {
  if (type == 'head') {
    const popoverstyle_poptable = {
      maxWidth: '550px',
    };
    const popover = (
      <PopOver style={popoverstyle_poptable}>
        <div className="poptable">
          <Table hideThead={false} data={leadsTagTips}>
            <Column name="enumValue" minWidth={80}>
              <strong>标签</strong>
            </Column>
            <Column name="enumDetail">
              <strong>说明</strong>
            </Column>
          </Table>
        </div>
      </PopOver>
    );
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }

  // 用户不能编辑的标签：系统标签+会话标签
  const uneditableTags = [];
  const editableTags = [];
  (data.tags || []).forEach((tag) => {
    const targetArr = tag.customizedTagGroup ? editableTags : uneditableTags;
    targetArr.push(tag);
  });
  const allTags = uneditableTags.concat(editableTags);
  const showMore = allTags.length > 2;
  const shownTags = allTags.slice(0, 2);
  const getTagTags = (arr) => arr.map((tag) => {
    const tagClassName = classNames({
      'leads-tag-in-table': true,
      'uneditable-tag': !tag.customizedTagGroup,
    });
    return (
      <span className={tagClassName} key={tag.tagId}>
        {tag.tagName}
      </span>
    );
  });
  const tagPoper = (
    <PopOver style={{ maxWidth: 310 }}>
      <div className="small-tags-wrapper">
        {getTagTags(allTags)}
      </div>
    </PopOver>
  );

  return (
    <div className="colum-tags">
      {getTagTags(shownTags)}
      {
        showMore && (
          <OverlayTrigger trigger="hover" delay={100} overlay={tagPoper}>
            <div className="more-tag-trigger svg-icon-more-tag"></div>
          </OverlayTrigger>
        )
      }
      <div onClick={() => this.handleEditLeadsTags(data)}
        className="edit-tag svg-icon-edit-with-pen"
      />
    </div>
  );
};

const renderPage = (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }

  let completeValue;
  if (value == '0' || value == undefined) {
    completeValue = '';
  } else {
    completeValue = data.pageName ? data.pageName.concat('(', value, ')') : value;
  }

  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue}...`; // `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderLeadsCallCleaningTag = (type, name, value, data) => {
  const popover = (
    <PopOver style={{ maxWidth: '550px' }}>
      <div className="poptable">
        <Table hideThead={true} data={leadsCallCleaningTagTips}>
          <Column name="enumValue" minWidth={80}>
            智能标签
          </Column>
          <Column name="enumDetail">定义</Column>
        </Table>
      </div>
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }
  return <span>{value || '-'}</span>;
};

const renderComponent = (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }

  let completeValue;
  if (!value) {
    completeValue = '';
  } else {
    completeValue = value; // data.componentName ? data.componentName.concat("(", value, ")") : value;
  }
  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue}...`; // `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderPoolWay = (type, name, value, data) => {
  if (type === 'head') return value;
  const map = {
    0: '新增',
    1: '回收',
    2: '释放',
  };
  return map[value] || map[0];
};

const renderCampainId = (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }

  let completeValue;
  if (!value || value == '0') {
    completeValue = '';
  } else {
    completeValue = data.campaignName ? data.campaignName.concat('(', value, ')') : value;
  }

  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderCreativeId = (type, name, value, data) => {
  const popover = (
    <PopOver style={{ maxWidth: '550px' }}>
      <div className="poptable">
        如果是非微信流量，该字段和投放端的广告创意ID字段保持一致，如果是微信流量，则对应的是ad_creative_id，该字段在投放端未展示。鉴于该字段不同流量对应字段不一致理解成本过高，后续将逐渐废弃该字段，请按需使用投放端创意字段或mkt api创意字段。
      </div>
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }

  let completeValue;
  if (!value || value == '0') {
    completeValue = '';
  } else {
    completeValue = data.creativeName ? data.creativeName.concat('(', value, ')') : value;
  }

  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderCreativeIdNew = (type, name, value, data) => {
  const popover = (
    <PopOver style={{ maxWidth: '550px' }}>
      <div className="poptable">
        对应投放端的广告创意
      </div>
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }

  let completeValue;
  if (!value || value == '0') {
    completeValue = '';
  } else {
    completeValue = data.creativeNameNew ? data.creativeNameNew.concat('(', value, ')') : value;
  }

  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderAdCreativeId = (type, name, value, data) => {
  const popover = (
    <PopOver style={{ maxWidth: '550px' }}>
      <div className="poptable">
        对应mkt api的广告创意
      </div>
    </PopOver>
  );
  if (type == 'head') {
    return (
      <div>
        {value}
        <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
          <i className="icon icon-help">
            <i></i>
          </i>
        </OverlayTrigger>
      </div>
    );
  }

  let completeValue;
  if (!value || value == '0') {
    completeValue = '';
  } else {
    completeValue = data.adCreativeName ? data.adCreativeName.concat('(', value, ')') : value;
  }

  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderPageUrl = (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }
  const showQrcode = (e) => {
    e.preventDefault();
  };
  const overlay = (
    <PopOver>
      <QrcodeOverlay _data={data} />
    </PopOver>
  );
  // TODO 判断需要展示二维码的条件
  if (data.leadsSource === 8) {
    return (
      <a onClick={showQrcode}>
        <OverlayTrigger placement="top" trigger="click" overlay={overlay}>
          点击查看预览二维码
        </OverlayTrigger>
      </a>
    );
  }
  return (
    <a href={data.pageUrl} target="_blank" rel="noreferrer">
      {data.pageUrl}
    </a>
  );
};
const renderAdId = (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }

  let completeValue;
  if (!value || value == '0') {
    completeValue = '';
  } else {
    completeValue = data.adName ? data.adName.concat('(', value, ')') : value;
  }
  // let showText;
  // if (completeValue && completeValue.length > 15) {
  //   showText = `${completeValue.substr(0, 15)}...`;
  // } else {
  //   showText = completeValue;
  // }
  return <div title={completeValue}>{completeValue}</div>;
};

const renderPlacement= (type, name, value, data) => {
  if (type == 'head') {
    return value;
  }
  const val = data?.placementShortId;
  let completeValue;
  if (!val || val == '0') {
    completeValue = '-';
  } else {
    completeValue = data.placementName ? data.placementName.concat('(', val, ')') : val;
  }
  let showText;
  if (completeValue && completeValue.length > 10) {
    showText = `${completeValue.substr(0, 10)}...`;
  } else {
    showText = completeValue;
  }
  const { leadsSource = '' } = data || {};
  // leadsSource:  8--mp原生落地页
  return leadsSource == 8? '暂未获取到广告位名称，待更新升级': <div title={completeValue}>{showText}</div>;
};


const renderQwOwner = (type, name, value, data) => {
  if (type === 'head') return value;

  if (!data.matchedWxWorkUserId) return '-';

  return (
    <ww-open-data type="userName" openid={data.matchedWxWorkUserId} />
  );
};

const renderAllRecord = (type, name, value = '', data) => {
  if (type === 'head') return value;

  if (value.length < 15) return value || '-';

  const popover = (
    <PopOver style={{ maxWidth: 550 }}>
      {value}
    </PopOver>
  );
  return (
    <div>
      <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
        <span>{value.slice(0, 14)}...</span>

      </OverlayTrigger>
    </div>
  );
};

const renderLeadsOpt = (type, name, value = '', data, tmcConfig, showDetail, showCallDialog) => {
    if (type === 'head') return value;

  // todo-elaine 判断商家是否开启线索数据脱敏功能
  // 商家开启线索数据脱敏功能后，才展示“添加微信”（若商家允许明文展示手机号，则不展示“添加微信”）
  // const isAddWxAvailable = true;

  // 是否可外呼
  const canCall =
    window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_AGENCY' &&
    window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ADOPERATOR' &&
    !isSubAccount();

    return (
      <div title={value}>
        <a onClick={showDetail}>
          详情
        </a>
        { canCall ? (
            <a onClick={showCallDialog}>
              呼叫
            </a>
          ) : (
            <span>呼叫</span>
          )
        }
        { judgeIsFromTMC() && (
          <a onClick={() => top.postMessage({ type: 'sendSms', data }, '*')}>
            发短信
          </a>
        )}
        { judgeIsFromTMC() && (tmcConfig?.leadsCommunicateAgainNotifyOwner === 'SMS_NOTIFICATION_ON') &&(
          <a style={data.leadsFollowTagName==='未分配'?{ color: '#aaa', cursor: 'no-drop' }:{}} onClick={() => {
            data.leadsFollowTagName!=='未分配' && top.postMessage({ type: 'followUpReminder', data }, '*')
          }}>
            跟进提醒
          </a>
        )}
      </div>
    );
  };

const getColumnsMap = function (customizedAttributes, _this) {
  const columnWidthStr = localStorage.getItem(`ColumnWidth${window.pageProps.uid}`);
  let columnWidth = undefined;
  if (columnWidthStr) {
    columnWidth = JSON.parse(columnWidthStr);
  }
  const getStyle = (name) => {
    if (!columnWidth) return {};
    if (!columnWidth[name]) return {};
    return { width: `${columnWidth[name]}px` };
  };
  const getItem = (id, name, renderFn) => {
    const obj = { name: id, title: name, style: getStyle(name), adjustWidth: true };
    if (typeof renderFn === 'function') obj.customRender = renderFn.bind(_this);
    return obj;
  };

  return {
    leadsId: getItem('leadsId', '线索ID'),
    leadsFollowTagName: {
      ...getItem('leadsFollowTagName', '线索状态', renderFollowTagName),
      fixedable: true,
    },
    matchedExternalUserName: {
      ...getItem('matchedExternalUserName', '微信昵称', renderWxNickname),
      fixedable: true,
    },
    leadsTagDesc: getItem('leadsTagDesc', '线索标签', renderLeadsTags),
    leadsCallCleaningTagName: getItem('leadsCallCleaningTagName', '智能标签', renderLeadsCallCleaningTag),
    touchTagName: getItem('touchTagName', '接通状态', renderTouchTagName),
    wechat: getItem('wechat', '微信'),
    qq: getItem('qq', 'QQ'),
    ownerName: getItem('ownerName', '当前归属人'),
    email: getItem('email', '邮箱'),
    idNumber: getItem('idNumber', '身份证'),
    sex: getItem('sex', '性别', renderSex),
    age: getItem('age', '年龄'),
    profession: getItem('profession', '职业'),
    workingYears: getItem('workingYears', '工作年限'),
    nationality: getItem('nationality', '国籍'),
    area: getItem('area', '所在地', renderFollowRecord),
    address: getItem('address', '详细地址'),
    // 线索列表列表 add by fightingliu
    customQa: getItem('customQa', '互动内容', renderCustomQa),
    bundle: getItem('bundle', '表单信息', renderBundle),
    telLocation: getItem('telLocation', '号码归属地'),
    advertiserId: getItem('advertiserId', '推广账号'),
    campaignId: getItem('campaignId', '推广计划', renderCampainId),
    enterPoolWay: getItem('enterPoolWay', '入池方式', renderPoolWay),
    // key 和 name 不一致
    adName: { name: 'adId', customRender: renderAdId, title: '广告', adjustWidth: true, style: getStyle('adName'), },
    // 列表页展示广告位名称 add by fighting
    placementName: { name: 'placementName', customRender: renderPlacement, title: '广告位', adjustWidth: true, style: getStyle('placementName'), },
    creativeId: getItem('creativeId', '创意(待废弃)', renderCreativeId),
    creativeIdNew: getItem('creativeIdNew', '投放端创意', renderCreativeIdNew),
    adCreativeId: getItem('adCreativeId', 'mkt api创意', renderAdCreativeId),
    pageId: getItem('pageId', '落地页', renderPage),
    componentId: getItem('componentId', '组件', renderComponent),
    pageUrl: getItem('pageUrl', '推广链接', renderPageUrl),
    consultUrl: getItem('consultUrl', '咨询页URL'),
    searchQueryWord: getItem('searchQueryWord', '搜索词'),
    searchKeyWord: getItem('searchKeyWord', '关键词'),
    clickId: getItem('clickId', '点击ID'),
    actionSubType: getItem('actionSubType', '线索类型', actionSubTypeRender),
    leadsSourceName: getItem('leadsSourceName', '线索来源'),
    shopName: getItem('shopName', '门店名称'),
    shopAddress: getItem('shopAddress', '门店地址'),
    actionTime: getItem('actionTime', '线索提交时间'),
    // lastUpadteTime: getItem('lastUpadteTime', '线索更新时间'),
    messageContent: getItem('messageContent', '留言内容'),
    mobileVerifyMethod: getItem('mobileVerifyMethod', '验证状态'),
    outerLeadsConvertType: getItem('outerLeadsConvertType', '自定义线索状态'),
    outerLeadsInEffectReason: getItem('outerLeadsInEffectReason', '自定义无效原因'),
    allFollowRecords: getItem('allFollowRecords', '全部跟进记录', renderAllRecord),
    relatedLeadsIds: getItem('relatedLeadsIds', '关联线索ID', renderRelatedLeadsIds),
    outerLeadsId: getItem('outerLeadsId', '第三方线索ID'),
    accountId: getItem('accountId', '归属账号ID', renderAccountId),
    layerFormContent: getItem('layerFormContent', '蹊径意向表单'),
    callTimes: getItem('callTimes', '通话次数', renderCallTimes),
    ownerLastChangedTime: getItem('ownerLastChangedTime', '线索分配时间'),
    isBroadCastLeads: getItem('isBroadCastLeads', '是否多发线索', renderBroadCast),
    // 房讯达楼盘字段
    leadsPoolId: getItem('leadsPoolId', getXundaPoolKeyName(), renderFxdPool),
    // 企微客户归属人
    matchedWxWorkUserId: getItem('matchedWxWorkUserId', '企微客户归属人', renderQwOwner),
    company: getItem('company', '公司'),
    ...(window.pageProps.isInnerAccount && {
      sourceAccountId: getItem('sourceAccountId', '来源广告主ID'),
      sourceLeadsId: getItem('sourceLeadsId', '来源线索ID'),
      lgMethod: getItem('lgMethod', 'LG处理方式', renderLgMethod),
    }),
    ...customizedAttributes.reduce((obj, item) => {
      obj[item.name] = getItem(item.name, item.name);
      return obj;
    }, {}),
  };
};

const SMART_TAGS = Object.keys(Tags.leadsCallCleaningTag).map((key) => {
  return {
    value: key,
    label: Tags.leadsCallCleaningTag[key],
  };
});
SMART_TAGS.splice(4, 0, SMART_TAGS.pop());
export const ENABLE_BATCH_TAG_UPDATE = true;
export const showTagEditor = (data) => {
  const div = document.createElement('div');
  div.className = 'extra-poper-container';
  document.body.appendChild(div);
  const hide = () => {
    unmountComponentAtNode(div);
    document.body.removeChild(div);
  };
  const singleUpdateLead = (tags) => {
    const tagIds = tags.map((tag) => tag.tagId);
    RPCFactory.leadsManage
      .updateLeadsLabel(data.leadsId, tagIds)
      .done(() => {
        if (typeof data.submitFn !== 'function') return;
        data.submitFn(tags);
      })
      .fail((ret, msg) => {
        window.alert(`操作失败,${msg}`);
      });
  };
  const batchUpdateLeads = (tags) => {
    const tagIds = tags.map((tag) => tag.tagId);
    let ids = data.leadsIds;
    if (!Array.isArray(ids)) {
      ids = [data.leadsId];
    }
    RPCFactory.leadsManage
      .batchUpdateLeadsLabel(ids, tagIds)
      .done(() => {
        if (typeof data.submitFn !== 'function') return;
        data.submitFn(tags);
      })
      .fail((ret, msg) => {
        window.alert(`操作失败,${msg}`);
      });
  };

  const updateFn = data.isBatch ? batchUpdateLeads : singleUpdateLead;

  render(
    <LeadsTagSelector
      show={true}
      hideAddLabelDialog={hide}
      selected={data.selected}
      setSelected={() => { }}
      leadsId={data.leadsId}
      updateFn={updateFn}
    />,
    div,
  );
};

// 线索来源
const leadsSourceIds = [];
Object.keys(Tags.leadsSourceTag).forEach((key) => {
  leadsSourceIds.push({ value: key, label: Tags.leadsSourceTag[key] });
});

// 线索评分
const leadsIntentionTags = [];
Object.keys(Tags.leadsIntentionTag).forEach((key) => {
  leadsIntentionTags.push({ value: key, label: Tags.leadsIntentionTag[key] });
});
// 接通状态
const leadsTouchTags = [];
leadsTouchTags.push({
  value: '0',
  label: '待联系',
});
leadsTouchTags.push({
  value: '4',
  label: '未接通-无效号码',
});
Object.keys(Tags.leadsTouchTag).forEach((key) => {
  if (key != '0' && key != '4') {
    leadsTouchTags.push({ value: key, label: Tags.leadsTouchTag[key] });
  }
});
const getFilterControl = () => {
  return [
    {
      name: 'startActionDate',
      title: '线索创建时间',
      type: 'date-picker',
      clearable: false,
      config: {
        type: 'range',
        longestRange: '365',
        useShortcut: true,
        shortcuts: dateShortcuts,
        optionalStartDate: '2018-06-01',
      },
    },
    {
      name: 'leadsCallCleaningTags',
      title: '智能标签',
      type: 'select',
      config: {
        multiple: true,
        data: SMART_TAGS,
      },
    },
    {
      name: 'actionSubTypes',
      title: '线索类型',
      type: 'select-tree',
      config: {
        multiple: true,
        data: leadsTypeTreeForTableFilter,
      },
    },
    {
      name: 'leadsSources',
      title: '线索来源',
      type: 'select',
      config: {
        multiple: true,
        data: leadsSourceIds,
      },
    },
    {
      name: 'leadsTouchTags',
      title: '接通状态',
      type: 'select',
      config: {
        multiple: true,
        data: leadsTouchTags,
      },
    },
    {
      name: 'intentionTags',
      title: '线索评分',
      type: 'select',
      config: {
        multiple: true,
        data: leadsIntentionTags,
      },
    },
    {
      name: 'name',
      title: '姓名',
      type: 'search',
    },
    {
      name: 'leadsId',
      title: '线索ID',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入线索ID' }],
    },
    {
      name: 'contact',
      title: '电话/微信/QQ',
      type: 'search',
      rules: [{ pattern: /^[a-zA-Z0-9_-]*$/, message: '请输入电话/微信/QQ' }],
    },
    {
      name: 'pageId',
      title: '落地页ID',
      type: 'search',
    },
    {
      name: 'email',
      title: '邮箱',
      type: 'search',
      rules: [{
        message: '请输入正确的邮箱',
        function(str) {
          if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]*$/.test(str)) return true;
          if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+\.?$/.test(str)) return true;
          if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]*$/.test(str)) return true;
          if (/^[a-zA-Z0-9_-]*$/.test(str)) return true;
          return false;
        },
      }],
    },
    {
      name: 'area',
      title: '所在地',
      type: 'search',
    },
    {
      name: 'address',
      title: '详细地址',
      type: 'search',
    },
    {
      name: 'componentName',
      title: '组件名称',
      type: 'search',
    },
    {
      name: 'advertiserId',
      title: '推广账号',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入推广账号' }],
    },
    {
      name: 'campaignId',
      title: '推广计划ID',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入推广计划ID' }],
    },
    {
      name: 'campaignName',
      title: '推广计划名称',
      type: 'search',
    },
    {
      name: 'adId',
      title: '广告ID',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入广告ID' }],
    },
    {
      name: 'adName',
      title: '广告名称',
      type: 'search',
    },
    {
      name: 'creativeId',
      title: '创意ID(待废弃)',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入创意ID' }],
    },
    {
      name: 'creativeName',
      title: '创意名称(待废弃)',
      type: 'search',
    },
    {
      name: 'creativeIdNew',
      title: '投放端创意ID',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入投放端创意ID' }],
    },
    {
      name: 'creativeNameNew',
      title: '投放端创意名称',
      type: 'search',
    },
    {
      name: 'adCreativeId',
      title: 'mkt api创意ID',
      type: 'search',
      rules: [{ pattern: /^\d*$/, message: '请输入mkt api创意ID' }],
    },
    {
      name: 'adCreativeName',
      title: 'mkt api创意名称',
      type: 'search',
    },
    // add by fighting 自定义筛选项
    {
      name: 'placementName',
      title: '广告位名称',
      type: 'search',
    },
    {
      name: 'matchedExternalUserName',
      title: '微信昵称',
      type: 'search',
    },
    {
      name: 'company',
      title: '公司',
      type: 'search',
    },
    // 筛选项 add by fightingliu
    {
      name: 'customQa',
      title: '互动内容',
      type: 'search',
    },
    {
      name: 'searchQueryWord',
      title: '搜索词',
      type: 'search',
    },
    {
      name: 'searchKeyWord',
      title: '关键词',
      type: 'search',
    },
  ];
};


const TestHeader = (props) => {
  useEffect(() => {
    const hiddenHeader = document.querySelector('.sec.sec-top-tab');
    hiddenHeader?.style?.setProperty('display', 'none');
    return () => {
      hiddenHeader?.style?.removeProperty('display');
    };
  }, []);

  return (
    <div className="sec-breadcrumb radius-collapse" style={{ borderRadius: '4px' }}>
      <div className="breadcrumb" style={{ marginTop: 5 }}>
        <a href={props.parentRouterPath} className="breadcrumb-back" role="button">
          <i className="icon icon-breadcrumb-back"></i>
        </a>
        <ol role="navigation" aria-label="breadcrumbs" className="breadcrumbs">
          <li>
            <a role="button" href={props.parentRouterPath}>
              {props.parentRouterText}
            </a>
          </li>
          <li>
            <a className="current">查看测试线索</a>
          </li>
        </ol>
      </div>
    </div>
  );
};

const LinkComponent = (props) => {
  const { className, onClick, children, data, value, name } = props;
  const self = this;
  return (
    <div className="spaui-menuitem-inner">
      <a className={className} onClick={onClick}>
        {children}
      </a>
      <span className="spaui-menuitem-action">
        <a
          href="javascript:void(0)"
          aria-label="编辑"
          onClick={(e) => {
            props.edit(data, value);
          }}
          className="editable-icon"
        >
          <i className="icon icon-pen"></i>
        </a>
        <a
          href="javascript:void(0)"
          aria-label="删除"
          onClick={(e) => {
            props.delete(data);
          }}
          className="delete-icon"
        >
          <i className="icon icon-delete"></i>
        </a>
      </span>
    </div>
  );
};
const getTipComponent = (self) => {
  const formTips = <span className="a-form-tips">设置后将应用于所有报表</span>;
  return (props) => {
    return (
      <div className="modal-footer-left">
        <div className="a-form-inline">
          <Checkbox
            value="1"
            checked={self.state.columnChecked}
            onChange={(e, value) => {
              self.columnChange(e, value, props);
            }}
          >
            保存为常用自定义列
          </Checkbox>
          {self.state.columnChecked ? (
            <Fragment>
              <FormGroup helpBlock={self.state.helpBlock} status={self.state.columnStatus}>
                <Input
                  size="small"
                  value={props.columnInputValue}
                  onChange={(e, value) => {
                    props.columnHandleInputChange(e, value, props);
                  }}
                />
              </FormGroup>
              {formTips}
            </Fragment>
          ) : (
            formTips
          )}
        </div>
      </div>
    );
  };
};

const handleColumnWidthChange = (event, columnWidthMap) => {
  console.log("width changed");
  localStorage.setItem(`ColumnWidth${window.pageProps.uid}`, JSON.stringify(columnWidthMap));
}
const defaultSelectedColumns = [
  'leadsTagDesc',
  'leadsCallCleaningTagName', // 自定义列调整为默认展示，位置放在线索ID左侧，线索标签右侧 by fightingliu
  'leadsId',
  'touchTagName',
  'callTimes',
  'allFollowRecords',
  'intentionScoreTagName',
  'ownerName',
  'telLocation',
  'actionSubType',
  'leadsSourceName',
  'adName',
  'advertiserId',
  'campaignId',
  'pageUrl',
  'bundle',
  'actionTime',
];

// 线索认领失败原因配置
export const leadsObtainErrorDict = {
    1: "因不允许认领本人被回收的线索，以下线索ID认领失败：",
    2: "因不允许跨团队认领线索，以下线索ID认领失败：",
    3: "因可认领线索数量达到上限，请减少认领线索数量或联系管理员调整当日线索接收数量上限，以下线索ID认领失败：",
    4: "因部分线索已被管理员分配至其他人或已被其他客服认领，请刷新页面后再操，以下线索ID认领失败：",
    5: "因其他原因认领失败，以下线索ID认领失败：",
}

export const leadsCommonFuncAndConfig = {
  defaultSelectedColumns,
  getTipComponent,
  LinkComponent,
  TestHeader,
  getColumnsMap,
  getFilterControl,
  leadsIntentionTags,
  leadsTouchTags,
  handleColumnWidthChange,
  renderLeadsOpt
};
